export default __webpack_public_path__ + "static/media/GHSI Special Board Minutes 24 August 2022.e7891c6e.pdf";